import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "memory" }
const _hoisted_2 = { class: "saved-memory" }
const _hoisted_3 = {
  key: 1,
  class: "empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_MemoryEditor = _resolveComponent("MemoryEditor")
  const _component_Divider = _resolveComponent("Divider")
  const _component_MemoryItem = _resolveComponent("MemoryItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, {
    class: "memory-frame",
    title: "Memory",
    description: "Manage what the agent remembers about you to provide more relevant answers in future chats"
  }, {
    right: _withCtx(() => [
      _createVNode(_component_Autosave, {
        saving: $options.saving,
        saved_at: $options.saved_at
      }, null, 8 /* PROPS */, ["saving", "saved_at"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MemoryEditor, {
          ref: "editor",
          saving: $options.saving,
          "at-limit": $options.at_limit,
          "symbol-limit": $data.SYMBOL_LIMIT,
          "memory-limit": $data.MEMORY_LIMIT,
          onAdd: $options.onAdd,
          onSave: $options.onSave
        }, null, 8 /* PROPS */, ["saving", "at-limit", "symbol-limit", "memory-limit", "onAdd", "onSave"]),
        _createVNode(_component_Divider, { h: "var(--col-height)" }),
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "Saved memories", -1 /* HOISTED */)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "description" }, "Review, edit, or delete what the agent remembers", -1 /* HOISTED */)),
          ($options.memories.length)
            ? (_openBlock(), _createBlock(_component_ScrollBar, {
                key: 0,
                class: "scrollbar",
                fade: "",
                "bar-x-offset": "0.4rem"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CollapseGroup, {
                    class: "list",
                    items: $options.memory_items,
                    duration: 300,
                    gap: "0.8rem"
                  }, {
                    default: _withCtx(({item}) => [
                      _createVNode(_component_MemoryItem, {
                        item: item,
                        disabled: $options.saving,
                        onEdit: $options.onEdit,
                        onDelete: $options.onRemove
                      }, null, 8 /* PROPS */, ["item", "disabled", "onEdit", "onDelete"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["items"])
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, "No saved memories yet"))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}